var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mainContent"},[_c('b-img',{staticClass:"logo",attrs:{"src":"/imgLogo.png"}}),_c('b-img',{staticClass:"calculating",attrs:{"src":"/calculating.gif"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }